export default class addServices {
    showModal(airport, validfor, oldval, vm) {

        console.log(oldval);
        if (oldval !== '') {
            oldval = JSON.parse(oldval);
        } else {
            oldval = [];
        }

        var oldsvc = [];
        $.each(oldval, function () {
            oldsvc.push(this['service']);
        });
        var ap = $("input[name=airport]").val();
        var modalhtml = '<div id="ServicesModal" class="modal fade"><div class="modal-dialog modal-lg"><div class="modal-content">' +
            '<div class="modal-header">' +
            '<h5 class="modal-title">' + window.translations.add_services[window.locale] + airport + '</h5>' +
            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"></button>' +
            '</div>' +

            '<div class="modal-body"><div id="adTmg"><table class="table table-striped" width="100%">';
        //get add Tavellers and M&Gs
        var hasA = false;
        $("input.adT.bg-red").each(function() {
            var v = $(this).val();
            if(v !='') {
                hasA = true;
                modalhtml += '<tr><td width="20%">'+$(this).data("name")+'</td><td width="60%">'+v+'</td><td width="20%">'+priceADT[ap]+'</td></tr>';
            }

        });
        $("input.mg.bg-red").each(function() {
            var v = $(this).val();
            if(v !='') {
                hasA = true;
                modalhtml += '<tr><td width="20%">'+$(this).data("name")+'</td><td width="60%">'+v+'</td><td width="20%">'+priceAMG[ap]+'</td></tr>';
            }
        });
        modalhtml += '</table></div>';
        if(hasA) {
            modalhtml += '<hr>';
        }

        modalhtml += '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">' + window.translations.cancel[window.locale] + '</button>';


        modalhtml += '<button id="okButton" type="button" class="btn btn-primary">' + window.translations.ok[window.locale] +
            '</button>' +
            '</div></div>' +
            '</div></div>'

        var confirmModal = $(modalhtml);

        confirmModal.find('#okButton').click(function (event) {
            var svcs = [];
            $(".modal-body input:checked").each(function () {
                console.log($(this));
                svcs.push({
                    'service': $(this).data('service'),
                    'description': $(this).data('description'),
                    'price': ($(this).data('price')).toString(),
                });

            });
            console.log(svcs);
            //$("input[name=additionalServices]").val(JSON.stringify(svcs));
            vm.form.additionalServices = JSON.stringify(svcs);
            confirmModal.modal('hide');
            confirmModal.on('hidden.bs.modal', function () {
                confirmModal.remove();
                $(".modal-backdrop").remove();
            })

        });
        confirmModal.on('hidden.bs.modal', function (e) {
            confirmModal.remove();
            $(".modal-backdrop").remove();
        });

        confirmModal.modal('show');

        confirmModal.on('shown.bs.modal', function(e) {
            var url = '/' + validfor + 'service/getaddservices';

            $.getJSON(url, {'ap': airport}, function (data) {
                console.log(data);

                var items = [];
                items.push("<thead><th>"+window.translations.service[window.locale]+"</th><th>"+window.translations.description[window.locale]+"</th><th>"+window.translations.price[window.locale]+"</th><th></th></thead>");
                $("<table/>", {
                    "class": "table table-striped table-services",
                    html: items
                }).appendTo(".modal-body");
                items = [];
                $.each(data, function (key, val) {
                    var checked = '';
                    if (oldsvc.indexOf(val['service']) > -1) {
                        checked = 'checked '
                    }
                    items.push("<tr><td>" + val['service'] + "</td><td>" + val['description'] +
                        "</td><td>" + val['price'] + "</td><td>" +
                        "<input type=\"checkbox\" " + checked +
                        "data-service=\"" + val['service'] + "\" data-description=\"" + val['description'] + "\" data-price=\"" + val['price'] + "\" class=\"form-check-input\"\"></td></tr>");
                });

                $("<tbody/>", {
                    html: items
                }).appendTo(".modal-body table.table-services");


            });
        });

    }


}